import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default markers in react-leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

interface MapProps {
  latitude?: string;
  longitude?: string;
  location?: {
    country: string;
    region: string;
    city: string;
  };
}

const Map: React.FC<MapProps> = ({ latitude, longitude, location }) => {
  // Convert string coordinates to numbers
  const lat = latitude ? parseFloat(latitude) : null;
  const lng = longitude ? parseFloat(longitude) : null;

  // Don't render map if coordinates are invalid
  if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
    return (
      <div className="map-container">
        <div className="map-placeholder">
        <div className="map-placeholder-content">
          <div className="map-placeholder-icon">⧉</div>
          <div className="map-placeholder-text">Location data not available</div>
        </div>
        </div>
      </div>
    );
  }

  const formatLocation = () => {
    if (!location) return 'Unknown Location';
    
    const parts = [];
    if (location.city && location.city !== 'Unknown') parts.push(location.city);
    if (location.region && location.region !== 'Unknown') parts.push(location.region);
    if (location.country && location.country !== 'Unknown') parts.push(location.country);
    
    return parts.length > 0 ? parts.join(', ') : 'Unknown Location';
  };

  return (
    <div className="map-container">
      <div className="map-header">
        <h3>Location Map</h3>
        <p>{formatLocation()}</p>
      </div>
      <MapContainer
        center={[lat, lng]}
        zoom={10}
        style={{ height: '300px', width: '100%' }}
        className="map"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[lat, lng]}>
          <Popup>
            <div className="map-popup">
              <strong>Your Location</strong>
              <br />
              {formatLocation()}
              <br />
              <small>
                Lat: {lat.toFixed(4)}, Lng: {lng.toFixed(4)}
              </small>
            </div>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default Map;
